import {
  Card,
  CardContent,
  ClickAwayListener,
  Grid,
  Tooltip,
  Typography,
} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Stack from "@mui/material/Stack";
import jwt_decode from "jwt-decode";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import {
  REACT_URL_COMPANYRPROFILE,
  REACT_URL_USERPROFILE,
} from "../../actions/EndPoints";
import CompanyBackgroundImg from "../../assets/CompanyBackgroundImg.svg";
import changePasswordDark from "../../assets/Profile Icons/ChangePasswordDark.svg";
import changePasswordHover from "../../assets/Profile Icons/ChangePasswordHover.svg";
import changePasswordLight from "../../assets/Profile Icons/ChangePassworsLight.svg";
import companyDark from "../../assets/Profile Icons/CompanyDark.svg";
import companyHover from "../../assets/Profile Icons/CompanyHover.svg";
import companyLight from "../../assets/Profile Icons/CompanyLight.svg";
import helpDark from "../../assets/Profile Icons/helpDark.svg";
import helpHover from "../../assets/Profile Icons/helpHover.svg";
import helpLight from "../../assets/Profile Icons/helpLight.svg";
import homeDark from "../../assets/Profile Icons/HomeDarkMode.svg";
import homeHover from "../../assets/Profile Icons/HomeHover.svg";
import homeLight from "../../assets/Profile Icons/HomeLightMode.svg";
import languagedark from "../../assets/Profile Icons/LanguageDark.svg";
import languageHover from "../../assets/Profile Icons/LanguageHover.svg";
import languageLight from "../../assets/Profile Icons/LanguageLight.svg";
import planDark from "../../assets/Profile Icons/planDark.svg";
import planHover from "../../assets/Profile Icons/planHover.svg";
import planLight from "../../assets/Profile Icons/planLight.svg";
import visitorCountDark from "../../assets/Profile Icons/visitorCountDark.svg";
import visitorCountHover from "../../assets/Profile Icons/visitorCountHover.svg";
import visitorCountLight from "../../assets/Profile Icons/visitorCountLight.svg";
import whatsNewDark from "../../assets/Profile Icons/whatsNewDark.svg";
import whatsNewHover from "../../assets/Profile Icons/whatsNewHover.svg";
import whatsNewLight from "../../assets/Profile Icons/whatsNewLight.svg";
import SignoutIcon from "../../assets/SignoutIcon.svg";
import SignoutIconDark from "../../assets/SignoutIconDark.svg";
import SignoutIconHover from "../../assets/SIgnOutIconHover.svg";
import Person from "../../assets/USA_Images/dashboard_icons/defaultprofile.svg";
import PersonDark from "../../assets/USA_Images/dashboard_icons/defaultProfileDark.svg";
import {
  getCompanyById,
  getCompanyInfo,
} from "../../slices/Company/CompanySlice";
import { revokeUser } from "../../slices/onboard/LoginSlice";
import { getCustomerSubscription } from "../../slices/Subscription/SubscriptionSlice";
import { getUserInfoPro } from "../../slices/User/UserSlice1";
import { ThemeContext } from "../../theme/ThemeContext";
import ChangePasswordDialog from "../DialogBoxComponent/ChangePasswordDialog";
import PlanDetailsDialog from "../DialogBoxComponent/PlanDetailsDialog";
import "../HeaderProfileMenu/HeaderProfileMenu.css";
import ProfileContext from "../ProfileContext";
import HoverHelper from "./HoverHelper";
import HoverImage from "./HoverImage";
import SelectLanguageMenu from "./SelectLanguageMenu";

function HeaderProfileMenu() {
  const dispatch = useDispatch();
  const history = useHistory();
  const store = useSelector((state) => state);
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [picture, setPicture] = useState("");
  const [name, setName] = useState("");
  const zlink = localStorage.getItem("redirectFrom");
  const [lastName, setLastName] = useState("");
  const [planName, setPlanName] = useState("");
  const [changePasswordDialog, setChangePasswordDialog] = useState(false);
  const [viewPlan, setViewPlan] = useState(false);
  const [price, setPrice] = useState("");
  const [customerPlan, setCustomerPlan] = useState({});
  const [companyDetails, setCompanyDetails] = useState({});
  const [parentDetails, setParentDetails] = useState({});
  const [isLogOutHovered, setIsLogOutHovered] = useState(false);

  const {
    userProfilePic,
    setUserProfilePic,
    userProfile,
    currentTotalVisitCount,
    setCurrentTotalVisitCount,
  } = useContext(ProfileContext);
  const [totalVisitLimitCount, setTotalVisitLimitCount] = useState("");
  const [currentVisitCount, setCurrentVisitCount] = useState("");
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);

  const [currentFilter, setCurrentFilter] = useState({
    status: [
      "SCHEDULED",
      "CONFIRMED",
      "APPROVED",
      "CHECKED_IN",
      "CHECKED_OUT",
      "CANCELLED",
      "INITIATED_FOR_BLOCKED",
      "BLOCKED",
      "REJECTED",
      "MISSED",
      "COMPLETED",
      "LOGGED",
    ],
    visitMode: [
      "INVITATION",
      "WALKIN_REGISTARTION",
      "SELF_REGISTARTION",
      "WALKIN_REGISTARTION_KIOSK",
    ],
  });

  var decoded_jwtToken = jwt_decode(
    localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
  );

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const location = useLocation();

  useEffect(() => {
    setAnchorEl(null);
  }, [location]);

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    loadData();
  }, [store.profile.profileUpdated, userProfile]);

  useEffect(() => {
    if (decoded_jwtToken.companyType === "CUSTOMER") {
      dispatch(getCustomerSubscription(decoded_jwtToken.companyId))
        .unwrap()
        .then((res) => {
          if (res.code === "MSGS4032" && res.data) {
            setCustomerPlan(res.data);
            setCurrentVisitCount(res.data.currentVisitsCreated);
            setCurrentTotalVisitCount(res.data.currentVisitsCreated);
            setTotalVisitLimitCount(
              res.data.subscriptionPurchaseId.maxVisitsCreation,
            );
          }
        });
    }
    dispatch(getCompanyInfo())
      .unwrap()
      .then((data) => {
        if (data.code === "UASI0026") {
          setCompanyDetails(data.data);
          if (data.data.parentId !== undefined || data.data.parentId === null) {
            dispatch(getCompanyById(data.data.parentId))
              .unwrap()
              .then((parentData) => {
                if (parentData.code === "UASI0026") {
                  setParentDetails(parentData.data);
                }
              });
          }
        }
      })
      .catch((er) => {});
  }, []);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  const loadData = () => {
    dispatch(getUserInfoPro(decoded_jwtToken.userId))
      .unwrap()
      .then((data) => {
        if ((data.code = "UASI0000" && data.data)) {
          setUserProfilePic(data.data.imagePreSignedURL);
          setName(data.data.firstName);
          setLastName(data.data.lastName);
        }
      })
      .catch((er) => {});
  };
  const label = { inputProps: { "aria-label": "Switch demo" } };
  const handleLogout = () => {
    // localStorage.removeItem('dark');
    history.push("/");
    dispatch(revokeUser());
    history.replace("/vis/login");
    localStorage.clear();
  };

  const handleChangePassword = () => {
    setChangePasswordDialog(!changePasswordDialog);
    setDiaLogBoxBlur(true);
  };

  const handlePlanClick = () => {
    setViewPlan(!viewPlan);
    setDiaLogBoxBlur(true);
  };

  return (
    <React.Fragment>
      {/* <ClickAwayListener onClickAway={handleClose}> */}
      <Box
        sx={{
          display: "revert",
          alignItems: "end",
          textAlign: "right",
          marginLeft: "-38px",
        }}
      >
        <Tooltip title={"Profile"}>
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{
              ml: 2,
              mr: 5,
              borderRadius: "8px",
              // opacity: 0.8,
              backgroundColor: "transparent",
              "&:hover": {
                opacity: 1,
                backgroundColor: "transparent",
              },
            }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <Avatar
              src={
                userProfilePic ? userProfilePic : darkMode ? PersonDark : Person
              }
              sx={{
                "& img": {
                  objectFit: userProfilePic ? "" : "none",
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                },
                backgroundColor: darkMode
                  ? "rgba(78, 96, 111, 1)"
                  : "#0F5A9C33",
                "&:hover": {
                  backgroundColor: darkMode ? "" : "#00000033",
                },
              }}
            />

            {/* <div style={{ padding: "5px" }}>
            <Typography
              // variant="h5"
              style={{ color: darkMode ? "white" : "#2281AB" }}
            >
              {name.length <= 12 ? name : name.substring(0, 12) + "..."}
            </Typography>
          </div>
          {open ? (
            <KeyboardArrowUpIcon fontSize="small"
              style={{
                paddingTop: "2.5px",
                color: darkMode ? "fff" : process.env.REACT_APP_ICON,
              }}
            />
          ) : (
            <KeyboardArrowDownIcon fontSize="small"
              style={{
                paddingTop: "2.5px",
                color: darkMode ? "fff" : process.env.REACT_APP_ICON,
              }}
            />
          )} */}
          </IconButton>
        </Tooltip>
      </Box>
      {/* </ClickAwayListener> */}

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        style={{
          borderRadius: "5px",
          marginLeft: "4px",
        }}
        PaperProps={{
          elevation: 0,
          sx: {
            mt: 1.5,
            width: "270px !important",
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            backgroundColor: darkMode ? "#1c354b" : "#fff",
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: process.env.REACT_APP_BG_HEADER_LOGO,
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <div style={{ backgroundColor: darkMode ? "#1c354b" : "#fff" }}>
          <Card
            sx={{
              bgcolor: darkMode
                ? "rgba(15, 90, 156, 0.8)"
                : process.env.REACT_APP_BG_HEADER_LOGO,
              backgroundImage: `url(${CompanyBackgroundImg})`,
              backgroundPosition: "bottom right",
              backgroundRepeat: "no-repeat",
              // opacity: 0.8,
              position: "relative",
              bottom: 9,
            }}
          >
            <CardContent
              style={{
                height: "100px",
              }}
            >
              <Grid container spacing={1} textAlign="left" p={1}>
                <Grid item xs={12}>
                  <div style={{ color: "#FFFFFF", display: "flex" }}>
                    <Tooltip title={name + "\n" + lastName}>
                      <Typography
                        noWrap
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          color: darkMode
                            ? "rgba(221, 221, 221, 1)"
                            : "#FFFFFF",
                        }}
                      >
                        {name + " " + lastName}
                      </Typography>
                    </Tooltip>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <Tooltip title={decoded_jwtToken.email}>
                    <Typography
                      noWrap
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        color: darkMode ? "rgba(221, 221, 221, 1)" : "#FFFFFF",
                      }}
                    >
                      {decoded_jwtToken.email}
                    </Typography>
                  </Tooltip>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <>
            <ClickAwayListener onClickAway={handleClose}>
              <Stack
                spacing={1}
                direction="column"
                sx={{
                  marginLeft: "10px",
                  marginRight: "10px",
                }}
                PaperProps={{
                  elevation: 10,

                  sx: {
                    opacity: 3,
                    bgcolor: "#FFFFFF",
                    position: "relative",
                  },
                }}
              >
                <Box onClick={handleClose}>
                  <HoverImage
                    normalImage={darkMode ? homeDark : homeLight}
                    hoverImage={homeHover}
                    alt="Profile"
                    item={t("DEALERTABPROFILE")}
                    link={REACT_URL_USERPROFILE}
                    darkMode={darkMode}
                  />
                </Box>
                <Box>
                  <SelectLanguageMenu
                    handleClose={() => setAnchorEl(null)}
                    normalImage={darkMode ? languagedark : languageLight}
                    hoverImage={languageHover}
                    alt="Language"
                    item={t("LANGUAGES_TEXT")}
                    darkMode={darkMode}
                  />
                </Box>
                <Box onClick={handleClose}>
                  <HoverImage
                    normalImage={darkMode ? companyDark : companyLight}
                    hoverImage={companyHover}
                    alt="Company"
                    item={t("COMPPROFSCREEN006")}
                    link={REACT_URL_COMPANYRPROFILE}
                    darkMode={darkMode}
                  />
                </Box>
                <Box
                  onClick={() => {
                    handleChangePassword();
                    handleClose();
                  }}
                >
                  <HoverImage
                    normalImage={
                      darkMode ? changePasswordDark : changePasswordLight
                    }
                    hoverImage={changePasswordHover}
                    alt="password"
                    item={t("RESETPASS002")}
                    darkMode={darkMode}
                  />
                </Box>

                {decoded_jwtToken.companyType === "CUSTOMER" && (
                  <Box
                    onClick={() => {
                      handlePlanClick();
                      handleClose();
                    }}
                  >
                    <HoverImage
                      normalImage={darkMode ? planDark : planLight}
                      hoverImage={planHover}
                      item={t("PLAN_TEXT") + planName}
                      darkMode={darkMode}
                    />
                  </Box>
                )}
                {!zlink && decoded_jwtToken.companyType === "CUSTOMER" && (
                  <Box onClick={handleClose} sx={{ margin: "0px 15px 0px" }}>
                    <HoverImage
                      normalImage={
                        darkMode ? visitorCountDark : visitorCountLight
                      }
                      hoverImage={visitorCountHover}
                      item={
                        t("VISITOR_COUNT_TEXT") +
                        " " +
                        currentTotalVisitCount +
                        "/" +
                        totalVisitLimitCount
                      }
                      darkMode={darkMode}
                    />
                  </Box>
                )}

                <Box
                  onClick={() => {
                    window.open(
                      `${process.env.PUBLIC_URL}/Whats_New.pdf`,
                      "_blank",
                      "noopener,noreferrer",
                    );
                    handleClose();
                  }}
                  sx={{ cursor: "pointer" }}
                >
                  <HoverImage
                    normalImage={darkMode ? whatsNewDark : whatsNewLight}
                    hoverImage={whatsNewHover}
                    item={t("CUSTDATABLE34")}
                    darkMode={darkMode}
                  />
                </Box>

                <Box>
                  <HoverHelper
                    normalImage={darkMode ? helpDark : helpLight}
                    hoverImage={helpHover}
                    item={t("HELP_TEXT")}
                    darkMode={darkMode}
                  />
                </Box>
                <Box
                  display="flex"
                  alignItems="center"
                  sx={{
                    width: "100%",
                    borderRadius: "8px",
                    cursor: "pointer",
                    marginBottom: "6px",
                    color: darkMode ? "#fff" : "",

                    "&:hover": {
                      backgroundColor: darkMode
                        ? "#33374a"
                        : "rgba(255,236,236,255)",
                      "& img": {
                        filter:
                          "brightness(0) saturate(100%) invert(36%) sepia(100%) saturate(7500%) hue-rotate(350deg)",
                      },
                      "& #logOut": {
                        color: "#F32C2C",
                        backgroundColor: "transparent",
                      },
                    },
                  }}
                  onClick={handleLogout}
                  onMouseEnter={() => setIsLogOutHovered(true)}
                  onMouseLeave={() => setIsLogOutHovered(false)}
                >
                  <img
                    // src={darkMode ? SignoutIconDark : SignoutIcon}
                    src={
                      isLogOutHovered
                        ? SignoutIconHover
                        : darkMode
                        ? SignoutIconDark
                        : SignoutIcon
                    }
                    alt="Signout Icon"
                    style={{ marginLeft: "20px", transition: "none" }}
                  />
                  <Typography
                    id="logOut"
                    sx={{
                      padding: "10px 8px",
                      fontSize: "16px",
                      fontFamily: "Roboto",
                      fontWeight: darkMode ? "500" : "500",
                    }}
                  >
                    {t("USERPROFCARD003")}
                  </Typography>
                  {/* <MenuItem
                  id="logOut"
                  style={{
                    padding: "10px 8px",
                    fontSize: "16px",
                    fontFamily: "Roboto",
                    fontWeight: darkMode ? "500" : "500",
                  }}
                >
                  {t("USERPROFCARD003")}
                </MenuItem> */}
                </Box>
              </Stack>
            </ClickAwayListener>
          </>
        </div>
      </Menu>
      {changePasswordDialog && (
        <ChangePasswordDialog
          open={changePasswordDialog}
          Header={t("RESETPASS002")}
          cancelText={t("COMMON008")}
          acceptText={t("COMMON007")}
          onClose={() => {
            setChangePasswordDialog(!changePasswordDialog);
            setDiaLogBoxBlur(false);
          }}
        />
      )}

      {viewPlan && (
        <PlanDetailsDialog
          open={viewPlan}
          planDetails={customerPlan}
          parentDetails={parentDetails}
          Header={t("SUBSCRIRPTION_DETAILS")}
          onClose={() => {
            setViewPlan(!viewPlan);
            setDiaLogBoxBlur(false);
          }}
        />
      )}
    </React.Fragment>
  );
}

export default HeaderProfileMenu;
